import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class externalMailingListView_template extends vnTemplate {

    protected buildViewModel(): any {
        let self = this
        return {
            id: ko.observable("")
            , idMailingList: ko.observable("")
            , label: ko.observable("")
            , onClickEditMailingList: function (data, event) {
                self.onClickEditMailingList(data.id());
            }
            , onClickCancel: function (data, event) {
                self.onClickCancel();
            }
        }
    }

    protected getTemplateHtml(): string {
        return (`
            <div class="w-form">
                
                <div class="form-header">
                    <button data-bind="event: { click: onClickCancel }" class="btn icon i-back" type="button">Go Back</button>
                    <h3 class="form-title" data-bind="text: label"></h3>
                    <div class="w-btn">
                         <button data-bind="event: { click: onClickEditMailingList }" class="btn icon i-edit"  type="button">Edit Mailing List</button>
                    </div>
                </div>
                
                <div class="w-form-body">
                    <div class="form-body">
                        <strong class="form-sub-title">Info</strong>
                    </div>
                </div>
                <div class="w-form-body">
                    <div class="form-body">
                        <div class="form-group">
                             <dl class="double-list">
                                <dt>
                                    <span>Mailing List ESP ID</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: idMailingList"></span>
                                </dd>
                                <dt>
                                    <span>Mailing List Label</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: label"></span>
                                </dd>
                             </dl>
                         </div>
                    </div>
                </div>
        `);
    }

    protected setMailingListData(mailingList) {
        this.getTemplateViewModel().id(mailingList.id)
        this.getTemplateViewModel().idMailingList(mailingList.idMailingList)
        this.getTemplateViewModel().label(mailingList.label)
    }

    protected getTemplateName(): string {
        return "mailingListView_template";
    }

    protected onClickEditMailingList(id: any): any {
        this.caller.onClickEditMailingList(id)
    }

    protected onClickCancel(): any {
        this.caller.onClickCancel()
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/externalMailingListView_template.ts